/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable react/default-props-match-prop-types */
import React, { FC } from 'react';
import { styled } from 'linaria/react';
import { withTheme } from '@shared/lib';
export interface SkeletonProps extends React.HTMLAttributes<HTMLDivElement> {
  height?: string | number;
  radius?: string | number;
}
const SkeletonRect: FC<SkeletonProps> = ({
  height = 16,
  radius = 8,
  ...rest
}) => <Rectangle height={height} radius={radius} {...rest} />;
const SkeletonCir: FC<Omit<SkeletonProps, 'radius'>> = ({
  height,
  ...rest
}) => <Round height={height as string} {...rest} />;
SkeletonRect.defaultProps = {
  height: 16,
  radius: 8
};
SkeletonCir.defaultProps = {
  height: 16
};
const radiusMap = (height: number, radius: number) => {
  switch (height) {
    case 24:
    case 20:
      return 6;
    case 16:
      return 4;
    case 8:
      return 2;
    default:
      return radius;
  }
};

// @ts-ignore
const _exp = /*#__PURE__*/() => ({
  height
}) => height;
const _exp2 = /*#__PURE__*/() => ({
  radius,
  height
}) => radius || radiusMap(Number(height), Number(radius));
const _exp3 = /*#__PURE__*/() => ({
  theme
}: ThemeProps) => theme.colors.bg.grey600;
const Rectangle = withTheme(/*#__PURE__*/styled('div')({
  name: "Rectangle",
  class: "r6arhmx",
  propsAsIs: false,
  vars: {
    "r6arhmx-0": [_exp(), "px"],
    "r6arhmx-1": [_exp2(), "px"],
    "r6arhmx-2": [_exp3()]
  }
}));

// @ts-ignore
const _exp7 = /*#__PURE__*/() => ({
  height
}) => height;
const _exp8 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.bg.grey600;
const Round = withTheme(/*#__PURE__*/styled('div')({
  name: "Round",
  class: "rn3hwm8",
  propsAsIs: false,
  vars: {
    "rn3hwm8-0": [_exp7(), "px"],
    "rn3hwm8-1": [_exp8()]
  }
}));
export { SkeletonRect, SkeletonCir };

require("./Skeleton.linaria.module.css!=!../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./Skeleton.tsx");